<template>
  <div class="headerContent">
    <!-- 顶部 -->
    <div class="top">
      <p class="top-p">山东省神经科学学会&nbsp;&nbsp;&nbsp;山东省阿尔茨海默病防治协会，欢迎您！&nbsp;&nbsp;<span class="desktop-only">{{ now }}</span></p>
      <p class="hover-p desktop-only">
        <a href="https://member.tiemeeting.com/3/Mpersonal/Account/Login" target="_blank" rel="noopener noreferrer">会员登录</a>
        <span style="color: #fff;">&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp;</span>
        <a href="http://sdssjkxxh.com:8080/" target="_blank" rel="noopener noreferrer">管理员登录</a>
      </p>
    </div>
    
    <!-- 主内容区 -->
    <div class="main-content">
      <!-- 图片 -->
      <div class="bottom">
        <img src="../../assets/public/xuehui.png" alt="" />
        <img src="../../assets/public/xiehui.png" alt="" />
      </div>
      
      <!-- 网页端搜索框 -->
      <div class="desktop-search-container desktop-only">
        <el-input
          v-model="searchValue"
          placeholder="请输入要搜索内容"
          clearable
          @keyup.enter="handleSearch"
        >
          <template #append>
            <el-button @click="handleSearch" type="primary">搜索</el-button>
          </template>
        </el-input>
      </div>
    </div>
    
    <!-- 移动端搜索框 -->
    <div class="mobile-search-container" v-show="isMobile">
      <el-input
        v-model="searchValue"
        placeholder="请输入要搜索内容"
        clearable
        @keyup.enter="handleSearch"
      >
        <template #append>
          <el-button @click="handleSearch" type="primary">搜索</el-button>
        </template>
      </el-input>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getNow, now } from '@/utils/getTime';
import { ref, onMounted, watch} from 'vue';
import { useRouter } from 'vue-router';
import { ElMessage } from 'element-plus';

const isMobile = ref(false);
// 修改检测移动端的逻辑
const checkMobile = () => {
  isMobile.value = window.innerWidth <= 768; // 改为768px及以下才认为是移动端
};

// 搜索框与路由
const router = useRouter();
const searchValue = ref('');
const hasShownEmptyWarning = ref(false);

// 监听路由变化，离开当前页时清空搜索框
watch(() => router.currentRoute.value.path, (newPath) => {
  if (newPath !== '/search') { // 如果不是跳转到搜索页
    searchValue.value = '';
  }
});

const handleSearch = () => {
  const keyword = searchValue.value.trim();
  
  if (!keyword) {
    if (!hasShownEmptyWarning.value) {
      ElMessage.warning('请输入搜索内容');
      hasShownEmptyWarning.value = true;
      
      setTimeout(() => {
        hasShownEmptyWarning.value = false;
      }, 3000);
    }
    return;
  }
  
  hasShownEmptyWarning.value = false;
  
  try {
    router.push({
      path: '/search',
      query: { keyword }
    });
  } catch (error) {
    ElMessage.error('搜索跳转失败');
    console.error('搜索跳转错误:', error);
  }
};

onMounted(() => {
  getNow();
  checkMobile();
  window.addEventListener('resize', checkMobile);
});
</script>

<style lang="scss" scoped>
.headerContent {
  width: 100%;
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  position: relative;
  padding-bottom: 30px; /* 为搜索框预留空间 */

  .top {
    width: 100%;
    height: 2.5rem;
    padding: 0 2%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    background-color: #1373C0;
    font-size: clamp(0.7rem, 0.7rem, 0.7rem); 
    white-space: nowrap;

    .top-p {
      font-size: 12px;
      color: #ffffff;
      padding: 0 17%;
    }
    .hover-p {
      font-size: 13px;
      cursor: pointer;
      padding: 0 17%;

      a {
        color: #ffffff;
        text-decoration-line: none;
        position: relative;
        transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          text-shadow: 0 0 5px rgb(255, 255, 255);
        }
      }
    }
  }
  
  .main-content {
    width: 100%;
    padding: 0 5%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    
    // 图片
    .bottom {
      display: grid;
      grid-template-columns: 1fr 1fr;
      align-items: center;
      gap: 7rem;
      margin-top: 20px;
      
      // img {
      //   width: auto;
      //   height: auto;
      //   object-fit: contain;
      // }
      img:first-child {
        width: 60%;
      }
      img:last-child {
        width:70%;
      }
    }
    
    // 网页端搜索框
    .desktop-search-container {
      align-self: flex-end; /* 靠右对齐 */
      margin-top: 20px; /* 与图片的间距 */
      margin-right: 15%; /* 与右侧的间距 */
      width: 300px;
      z-index: 10; /* 确保在菜单栏上方 */
      
      :deep(.el-input) {
        width: 100%;
        border-radius: 30px;
        box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
        
        .el-input__wrapper {
          background: #fff;
          border-radius: 30px 0px 0px 30px;
          padding: 0 1.25rem;
          box-shadow: none;
          height: 2.5rem;
          
          .el-input__inner {
            color: #282828;
            font-size: 1rem;
            &::placeholder {
              color: #999;
            }
          }
        }
        
        .el-input-group__append {
          background: linear-gradient(135deg, #1373C0 0%, #0d5a9e 100%);
          border: none;
          border-radius: 0 30px 30px 0;
          padding: 0 1.5rem;
          
          .el-button {
            font-size: 0.9rem;
            color: white;
            font-weight: 500;
          }
        }
      }
    }
  }

  // 移动端搜索框
  .mobile-search-container {
    width: 90%;
    max-width: 500px;
    margin: 10px auto;
    display: none;
    
    :deep(.el-input) {
      width: 100%;
      border-radius: 30px;
      box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
      
      .el-input__wrapper {
        background: #fff;
        border-radius: 30px 0px 0px 30px;
        padding: 0 1.25rem;
        box-shadow: none;
        height: 2.5rem;
        
        .el-input__inner {
          color: #282828;
          font-size: 1rem;
          &::placeholder {
            color: #999;
          }
        }
      }
      
      .el-input-group__append {
        background: linear-gradient(135deg, #1373C0 0%, #0d5a9e 100%);
        border: none;
        border-radius: 0 30px 30px 0;
        padding: 0 1.5rem;
        
        .el-button {
          font-size: 0.9rem;
          color: white;
          font-weight: 500;
        }
      }
    }
  }
}

@media (max-width: 768px) {
  .desktop-only {
    display: none !important;
  }
  
  .headerContent {
    padding-bottom: 0;
    
    .main-content {
      padding: 0;
      
      .bottom {
        gap: 1rem;
        margin-top: 10px;
      }
    }
  }
}

@media (max-width: 768px) {
  .headerContent {
    .top {
      padding: 0 5%;
      font-size: 12px !important;
      flex-direction: column;
      height: auto;
      padding: 10px 0;
      
      .top-p, .hover-p {
        font-size: 14px !important;
        width: 100%;
        text-align: center;
        padding: 5px 0 !important;
      }
    }
    
    .main-content .bottom {
      display: flex !important;
      flex-direction: column;
      gap: 0rem !important;
      margin-top: 10px !important;
      align-items: center;
      
      // img {
      //   max-width: 80% !important;
      //   margin: 0 auto;
      // }
      
      img:first-child {
        margin-bottom: 10px;
        width: 60%;
      }
      img:last-child {
        margin-bottom: 10px;
        width: 70%;
      }
    }
    
    .mobile-search-container {
      display: block;
    }
  }
}

@media (max-width: 480px) {
  .headerContent {
    .top {
      .top-p {
        font-size: 11px;
      }
      .hover-p {
        font-size: 12px;
      }
    }
    
    .mobile-search-container {
      width: 95%;
      
      :deep(.el-input) {
        .el-input__wrapper {
          padding: 0 1rem;
          height: 2.2rem;
        }
        
        .el-input-group__append {
          padding: 0 1rem;
        }
      }
    }
  }
}
</style>